import React, { Fragment, useState, useEffect } from 'react';
import { Redirect, withRouter } from 'react-router-dom';

function withRedirect(WrappedComponent) {

  return function (props) {

    const [redirectTo, setRedirectTo] = useState(null);
    let mountedFlag;

    const redirect = function (path) {
      const { history } = props;
      const historyPath = path[0] === '/' ? path : `/${path}`;
      history.push(historyPath);
      if (mountedFlag) {
        setRedirectTo(path);
      }
    }

    useEffect(() => {
      mountedFlag = true;
      return () => {
        mountedFlag = false;
      }
    })
    return (
      <Fragment>
        {redirectTo !== null ? <Redirect to={redirectTo} /> : null}
        <WrappedComponent
          {...props}
          redirect={redirect}
        />
      </Fragment>
    )
  }
}

export default (Component) => withRouter(withRedirect(Component));